'use client'

import { useOptimizedRecords } from '@/shared/hooks/useOptimizedQuery'
import { Title } from '@/shared/types/user'

export function useUserTitles() {
  return useOptimizedRecords<Title>({ path: '/user/titles' })
}
